module.exports = __webpack_public_path__ + "img/mgh-gotanda-sp@2x.f9fd5fa3.jpg";